import { Button } from "@/components/ui/button";

import { PlusIcon } from "lucide-react";

type BranchesToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
};

export function BranchesToolbar({ canManage, onCreate }: BranchesToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div className="flex flex-col">
          <h2 className="flex items-center font-bold text-2xl tracking-tight">
            ສາຂາ
          </h2>
          <p className="text-muted-foreground">ຈັດການສາຂາ ແລະ ຕັ້ງຄ່າບໍລິການ.</p>
        </div>
        {canManage && (
          <div className="flex items-center space-x-2">
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງສາຂາ
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
